/**
 * Theme mode
 *
 * These modes are used in our App context and sets the theme used
 * in our app independently of being set by the system or by the user.
 * The "theme-mode" item in local storage also uses these values.
 */
export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}
